module.exports = __webpack_public_path__ + "static/media/m9cr658.b8f692b6.png";